export class SwiperHelpers{
    constructor() {
        this.handleSlideChangeTransitionEnd = function (swiper) {
            //Fix the tabindex for accebility
            swiper.el
                .querySelectorAll(" .swiper-slide > a")
                .forEach((slide) => {
                    slide.setAttribute("tabindex", "-1");
                });
    
            const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
            );
            if (activeSlide != null) {
                activeSlide.setAttribute("tabindex", "0");
            }
        };
    
        this.handleSlideChange = function () {
            //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
            var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
            if (nextDuplicateSlide != null) {
                var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
                if (unloadedSlideImage != null) {
                    unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
                }
            }
        }

    }
};
export default new SwiperHelpers();